import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { AuditEventType } from '@/types/auditLogTypes';

export const getAuditEventsApi = (params?: ApiParams): Promise<ApiResponseType<ListResponseType<AuditEventType>>> => {
  return authApiService.GET('/audit-log/events/', params);
};
